import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
export const Portal = ({ children }) => {
    const [container] = useState(() => {
        const el = document.createElement("div");
        el.setAttribute("id", "portal");
        return el;
    });
    useEffect(() => {
        document.body.appendChild(container);
        return () => {
            document.body.removeChild(container);
        };
    }, []);
    return createPortal(children, container);
};
